<template>
	<div class="mycenter-page">
		<div class="menu-box">
			<ul>
				<li v-for="item in myCenterMenuList" :key="item.code">
					<div class="selected" v-if="isSelected === item.code"></div>
					<div class="menu-content" @click="goFunc(item);">
						<div class="img-box"><i :class="'iconfont ' + item.icon"></i></div>
						<div class="name">{{ item.name }}</div>
					</div>
				</li>
			</ul>
		</div>
		<div class="mycenter-content-box">
			<transition name="fade-transform" mode="out-in">
				<router-view :key="key" />
			</transition>
		</div>
	</div>
</template>

<script>
	import {
		mapGetters
	} from 'vuex';
	
	export default {
		name: 'mycenter',
		data() {
			return {
				isSelected: 'wddd',
				myCenterMenuList: []
			};
		},
		computed: {
			...mapGetters(['vuex_myCenterSelectedMenu', 'userInfo']),
			
			key() {
				return this.$route.path;
			}
		},
		watch: {
			'vuex_myCenterSelectedMenu': {
				handler(val) {
					this.$set(this.$data, 'isSelected', val)
				},
				immediate: true
			}
		},
		beforeMount() {
			// 业务员不展示账户
			if (this.userInfo.enterpriseType == 'SALESMAN') {
				this.myCenterMenuList = this.mixin_myCenterMenuList.filter(item => item.code != 'wdzh');
			}
			else {
				this.myCenterMenuList = this.mixin_myCenterMenuList;
			}
			
			let funcs = this.mixin_myCenterMenuList.filter(item => item.path === this.$route.path);

			if (funcs.length > 0) {
				this.isSelected = funcs[0].code;
			}
		},
		methods: {
			goFunc(item) {
				if (item.path) {
					this.isSelected = item.code;
					this.$store.commit('SET_MYCENTERSELECTEDMENU', item.code);
					this.$router.push(item.path);
				}
			}
		}
	}
</script>

<style lang="scss" rel="stylesheet/scss">
	@import "@/assets/css/szui.scss";

	.mycenter-page {
		display: flex;
		justify-content: flex-start;
		align-items: flex-start;

		@keyframes fade-in {
			from {
				height: 0;
			}

			to {
				height: 28px;
			}
		}

		.menu-box {
			flex-shrink: 0;
			position: relative;
			padding: 15px 0;
			width: 230px;
			height: 386px;
			background: #FFFFFF;
			border-radius: 10px;
			box-sizing: border-box;

			ul::-webkit-scrollbar {
				width: 0;
				height: 0;
			}

			ul {
				margin: 0px;
				padding: 0px;
				height: 100%;
				list-style: none;
				overflow: scroll;

				li {
					position: relative;
					padding: 0 10px;
					cursor: pointer;

					.selected {
						position: absolute;
						top: 50%;
						left: 0;
						transform: translateY(-50%);
						width: 4px;
						height: 28px;
						background: #FECE36;
						animation-name: fade-in;
						animation-duration: .3s;
					}

					.menu-content {
						display: flex;
						justify-content: space-between;
						align-items: center;
						padding: 15px 10px 15px 38px;
						width: 210px;
						height: 44.3px;
						border-radius: 8px;
						box-sizing: border-box;

						.img-box {
							flex-shrink: 0;
							width: 20px;

							.iconfont {
								color: #606366;
							}

							.icon-wodedingdan {
								font-size: 20px;
							}

							.icon-wodezhanghu,
							.icon-xinpinshouji,
							.icon-lingquanzhongxin {
								font-size: 17px;
							}

							.icon-guanyuwomen {
								font-size: 19px;
							}

							.icon-shouhuodizhi {
								font-size: 21px;
							}

							.icon-kefufuwu,
							.icon-jingyingzizhi,
							.icon-zhanghao {
								font-size: 18px;
							}
						}

						.name {
							flex: 1;
							margin-left: 12px;
							font-size: 14px;
							color: $fontColor;
						}
					}
				}

				li:hover {
					.menu-content {
						background: #F5F7FA;
					}
				}
			}
		}

		.mycenter-content-box {
			flex: 1;
			margin-left: 10px;
		}
	}
</style>
